import api from '../../api/api.js'
import utils from '../../utils/utils.js'
import { Message } from 'element-ui'
import deduction from '../../api/moudles/deduction.js'


const state = () => ({
	storeBindShopList:JSON.parse(localStorage.getItem('storeBindShopList')) ? JSON.parse(localStorage.getItem('storeBindShopList')) : []
   
})

const getters ={
	
}

const actions = {
	//获取仓库帐号绑定的所有卖家帐号
	// getStroeSeller({state,dispatch}, payload) {
	// 	deduction
	// 		.getStroeSeller(payload)
	// 		.then(res => {
	// 			if (res.code === 200) {
	// 				console.log('获取仓库帐号绑定的所有卖家帐号',res.data)
	// 				res.data.forEach(p => {
	// 					p.checked=false
	// 				})
	// 				state.storeBindShopList=res.data
	// 				localStorage.setItem('storeBindShopList',JSON.stringify(state.storeBindShopList))
	// 			}
	// 		})
	// }
}

const mutations= {
	
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



